import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintReport } from '.';

/**
 * @component {kat-blueprint-report-focus} KatBlueprintReportFocus Component used to place and filter components within the focus section.
 * @slot default Blueprint content for focus section.
 */
@register(KatBlueprintReport.slotMapping.focus.name)
export class KatBlueprintReportFocus extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintReport.slotMapping.focus.name,
      KatBlueprintReport.slotMapping.focus.allowed
    );
  }
}
